

import { usePrivateMutation as useMutation } from "@/lib/query/core/use-private-mutation";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";

type UpdateAdminPasswordInput = {
  adminId: string;
  password: string;
};

export function useUpdateAdminPasswordMutation() {
  const mutation = useMutation({
    mutationFn: ({ adminId, password }: UpdateAdminPasswordInput) =>
      apiJsonClient<unknown>(endpoints.admin.adminPassword(adminId), {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      }),
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
